import { Icon, styled, Tooltip } from 'imaginarity-react-ui';
import * as React from 'react';

const Conatainer = styled.span`
    margin-left: 5px;
    width: 15px;
    overflow: hidden;
`;


export interface MissingInputHintProps {
    // isMissingInput: boolean;
    tooltipErrorText?: string;
    hideSuccessIcon?: boolean;
}
const MissingInputHint = (p: MissingInputHintProps) => {
    const { /*isMissingInput,*/ tooltipErrorText, hideSuccessIcon } = p;
    const isMissingInput = tooltipErrorText !== undefined;
    const errorIcon = <Icon name="asterisk" marginTop={0} size="1em" color={"@accent"} style={{ transform: "translateY(2px)" }} />;
    const successIcon = <Icon name="check" marginTop={0} size="1em" color={"@accentGreen"} style={{ transform: "translateY(3px)" }} />;
    return (
        <Conatainer>
            {tooltipErrorText ?
                isMissingInput ? <Tooltip noMargin tooltipText={tooltipErrorText} position='bottom'>{errorIcon}</Tooltip> : (!hideSuccessIcon && successIcon)
                :
                isMissingInput ? errorIcon : (!hideSuccessIcon && successIcon)}
        </Conatainer>
    );
}
export default MissingInputHint;